module.exports = __webpack_public_path__ + "img/gold4.0aaf2f93.png";